module.exports = __webpack_public_path__ + "img/sanma.0b923748.png";